import React from 'react'
import Grades from 'src/modules/MyClass/Grades'

const GradesPage = () => {
  return <Grades />
}

export default GradesPage
